import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SetLocationRequest } from 'app/generated/backend/shipment/api/set-location-request';
import { SetLocationResponse } from 'app/generated/backend/shipment/api/set-location-response';

@Injectable()
export class SetLocationHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: SetLocationRequest
	): Observable<JsonResourceResponse<SetLocationResponse>> {
		return this.http.post<JsonResourceResponse<SetLocationResponse>>('api/v1/shipment/setLocation', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		SetLocationHandlerService
	]
})
export class SetLocationHandlerModule { }
